import { KelpLrtOracleAbi } from '../abis/kelp'
import { TotalSupplyAbi } from '../abis/shared'
import type { LstRegistryEntry } from '../registry'
import { ONE_E18, toBigInt, type LstReader } from './shared'

/**
 * Kelp rsETH reader.
 *
 * Two calls: `rsETH.totalSupply()` + `LRTOracle.rsETHPrice()`.
 * Oracle returns the 1e18-scaled ETH-per-rsETH price.
 *
 * Fallback: when `readerExtras.lrtOracle` is absent, surface a 1:1
 * placeholder rate.
 */
export const readerKelpRsEth = (entry: LstRegistryEntry): LstReader => {
  const oracle = entry.readerExtras?.lrtOracle
  if (!oracle) {
    return {
      calls: [{ address: entry.address, name: 'totalSupply', params: [] }],
      abis: [TotalSupplyAbi],
      parse: ([supply]) => {
        const totalSupply = toBigInt(supply)
        if (totalSupply === undefined) return undefined
        return {
          totalAssets: totalSupply,
          totalSupply,
          exchangeRate: ONE_E18,
        }
      },
    }
  }
  return {
    calls: [
      { address: entry.address, name: 'totalSupply', params: [] },
      { address: oracle, name: 'rsETHPrice', params: [] },
    ],
    abis: [TotalSupplyAbi, KelpLrtOracleAbi],
    parse: ([supply, rate]) => {
      const totalSupply = toBigInt(supply)
      const exchangeRate = toBigInt(rate)
      if (totalSupply === undefined || exchangeRate === undefined) {
        return undefined
      }
      return {
        totalAssets: (totalSupply * exchangeRate) / ONE_E18,
        totalSupply,
        exchangeRate,
      }
    },
  }
}
